var _circle, _rect, _rect2, _g, _path, _line, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingIssues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 242,
    viewBox: "0 0 314 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121.844,
    cy: 121,
    r: 120.5,
    fill: "#7AB8B1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 71.3435,
    y: 49.8584,
    width: 133.189,
    height: 163.925,
    transform: "rotate(-11.4873 71.3435 49.8584)",
    fill: "#CBEACE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 157.582,
    y: 9.36277,
    width: 133.189,
    height: 163.925,
    transform: "rotate(6.7187 157.582 9.36277)",
    fill: "#CBEACE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2894_8399)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.914,
    y: 7.5,
    width: 133.189,
    height: 163.925,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.711 29.6863H140.617V45.3337H137.711V29.6863ZM158.753 29.6863V45.3337H156.361L147.732 34.7382V45.3337H144.849V29.6863H147.241L155.869 40.2818V29.6863H158.753ZM177.143 29.6863L170.325 45.3337H167.464L160.623 29.6863H163.775L168.984 41.7571L174.237 29.6863H177.143ZM185.929 45.5572C184.334 45.5572 182.896 45.2145 181.614 44.529C180.333 43.8286 179.327 42.8674 178.597 41.6454C177.867 40.4085 177.501 39.03 177.501 37.51C177.501 35.99 177.867 34.6189 178.597 33.397C179.327 32.1601 180.333 31.1989 181.614 30.5134C182.896 29.813 184.334 29.4628 185.929 29.4628C187.523 29.4628 188.961 29.813 190.243 30.5134C191.525 31.1989 192.53 32.1526 193.261 33.3746C193.991 34.5966 194.356 35.9751 194.356 37.51C194.356 39.0449 193.991 40.4234 193.261 41.6454C192.53 42.8674 191.525 43.8286 190.243 44.529C188.961 45.2145 187.523 45.5572 185.929 45.5572ZM185.929 43.0089C186.972 43.0089 187.911 42.7779 188.745 42.316C189.58 41.8391 190.235 41.1834 190.712 40.3489C191.189 39.4994 191.428 38.5531 191.428 37.51C191.428 36.4668 191.189 35.528 190.712 34.6935C190.235 33.844 189.58 33.1883 188.745 32.7264C187.911 32.2495 186.972 32.011 185.929 32.011C184.886 32.011 183.947 32.2495 183.112 32.7264C182.278 33.1883 181.622 33.844 181.145 34.6935C180.668 35.528 180.43 36.4668 180.43 37.51C180.43 38.5531 180.668 39.4994 181.145 40.3489C181.622 41.1834 182.278 41.8391 183.112 42.316C183.947 42.7779 184.886 43.0089 185.929 43.0089ZM197.436 29.6863H200.342V45.3337H197.436V29.6863ZM211.817 45.5572C210.237 45.5572 208.807 45.2145 207.525 44.529C206.258 43.8286 205.26 42.8674 204.53 41.6454C203.814 40.4234 203.457 39.0449 203.457 37.51C203.457 35.9751 203.822 34.5966 204.552 33.3746C205.282 32.1526 206.281 31.1989 207.547 30.5134C208.829 29.813 210.26 29.4628 211.839 29.4628C213.121 29.4628 214.291 29.6863 215.349 30.1334C216.407 30.5804 217.301 31.2287 218.031 32.0781L216.153 33.844C215.021 32.622 213.628 32.011 211.973 32.011C210.9 32.011 209.939 32.2495 209.09 32.7264C208.24 33.1883 207.577 33.8366 207.1 34.6711C206.623 35.5056 206.385 36.4519 206.385 37.51C206.385 38.568 206.623 39.5143 207.1 40.3489C207.577 41.1834 208.24 41.8391 209.09 42.316C209.939 42.7779 210.9 43.0089 211.973 43.0089C213.628 43.0089 215.021 42.3905 216.153 41.1536L218.031 42.9419C217.301 43.7913 216.399 44.4395 215.326 44.8866C214.268 45.3337 213.099 45.5572 211.817 45.5572ZM232.551 42.8972V45.3337H220.816V29.6863H232.238V32.1228H223.722V36.1911H231.277V38.583H223.722V42.8972H232.551Z",
    fill: "#55857E"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 138.404,
    y1: 53.1383,
    x2: 234.338,
    y2: 53.1383,
    stroke: "#55857F",
    strokeWidth: 1.86279
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.508 136.032C202.254 136.032 216.641 121.646 216.641 103.899C216.641 86.1526 202.254 71.7661 184.508 71.7661C166.761 71.7661 152.375 86.1526 152.375 103.899C152.375 121.646 166.761 136.032 184.508 136.032Z",
    stroke: "url(#paint0_linear_2894_8399)",
    strokeWidth: 4.81996
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.483 93.8576C178.484 92.8025 178.761 91.7659 179.287 90.8516C179.814 89.9372 180.571 89.1772 181.484 88.6476C182.396 88.1179 183.432 87.8372 184.487 87.8335C185.542 87.8298 186.58 88.1032 187.496 88.6265C188.412 89.1497 189.175 89.9044 189.708 90.815C190.241 91.7256 190.526 92.7603 190.533 93.8153C190.541 94.8704 190.271 95.909 189.751 96.8272C189.231 97.7453 188.479 98.5108 187.571 99.0471C186.044 99.95 184.508 101.322 184.508 103.096V107.112",
    stroke: "url(#paint1_linear_2894_8399)",
    strokeWidth: 4.81996,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184.508 119.966C186.283 119.966 187.721 118.527 187.721 116.752C187.721 114.978 186.283 113.539 184.508 113.539C182.733 113.539 181.295 114.978 181.295 116.752C181.295 118.527 182.733 119.966 184.508 119.966Z",
    fill: "url(#paint2_linear_2894_8399)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2894_8399",
    x: 108.6,
    y: 1.91164,
    width: 151.817,
    height: 182.553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.72557
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.65696
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2894_8399"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2894_8399",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2894_8399",
    x1: 184.508,
    y1: 71.7661,
    x2: 184.508,
    y2: 136.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#2B3C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#C5D6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#55857F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55857E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2894_8399",
    x1: 184.508,
    y1: 87.8335,
    x2: 184.508,
    y2: 107.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#2B3C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#C5D6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#55857F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55857E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2894_8399",
    x1: 184.508,
    y1: 113.539,
    x2: 184.508,
    y2: 119.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#2B3C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#C5D6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#55857F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55857E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIssues);
export default __webpack_public_path__ + "static/media/billing-issues.5b9761da16f2717db99b1452e991bbfe.svg";
export { ForwardRef as ReactComponent };